import { useMemo } from 'react';

import { OrganizationRolePermission } from 'src/domain/organization';

import { useCreatorRoleContext } from './useCreatorRoleContext';

type PermissionScope = 'active' | 'any';

type UseCreatorRolePermissionOptions = {
    scope?: PermissionScope;
    allowOrganization?: boolean;
};

export const useCreatorRolePermission = (
    permission: OrganizationRolePermission,
    options: UseCreatorRolePermissionOptions = {},
): boolean => {
    const { isCreator, roles, activeRoleId } = useCreatorRoleContext();
    const scope = options.scope ?? 'active';
    const allowOrganization = options.allowOrganization ?? true;

    return useMemo(() => {
        if (allowOrganization && !isCreator) {
            return true;
        }

        if (!isCreator) {
            return false;
        }

        if (scope === 'any') {
            return roles.some(roleEntry =>
                roleEntry.permissions?.includes(permission),
            );
        }

        const activeRole = roles.find(
            roleEntry => roleEntry.id === activeRoleId,
        );
        return Boolean(activeRole?.permissions?.includes(permission));
    }, [activeRoleId, allowOrganization, isCreator, permission, roles, scope]);
};
